/**
 * How the daily dispatch sheet is read: as the wide printable table, or as a
 * column of portrait dispatch orders.
 *
 * The two are the same report — `src/core/dispatch-report.ts` builds the rows
 * either way — so what lives here is only the choice itself and the rule for
 * which one a screen opens on. It is a module of its own so the toggle, the
 * sheet and the healthcheck all name the two views identically.
 */

export const DISPATCH_VIEWS = ['cards', 'table'] as const;

export type DispatchView = (typeof DISPATCH_VIEWS)[number];

export const DISPATCH_VIEW_LABELS: Record<DispatchView, string> = {
  cards: 'תצוגת כרטיסים לאורך',
  table: 'טבלה רוחבית',
};

/** Paper is always the table — a printer has the width a phone does not. */
export const DEFAULT_DISPATCH_VIEW: DispatchView = 'table';

/** Wider than this and the six-column sheet fits on screen; narrower and it does not. */
export const DISPATCH_MOBILE_BREAKPOINT = 768;

/**
 * The view a screen of this width opens on. A phone gets the portrait cards, so
 * the sheet is legible the moment it is opened rather than after the reader has
 * scrolled sideways to find the crew column.
 */
export function defaultDispatchViewFor(width: number | null | undefined): DispatchView {
  const value = Number(width);
  if (!Number.isFinite(value) || value <= 0) return DEFAULT_DISPATCH_VIEW;
  return value < DISPATCH_MOBILE_BREAKPOINT ? 'cards' : 'table';
}
